<template>
  <div>
    <v-card class="pa-3">
      <v-card-title>
        Lager Anlegen
      </v-card-title>
      <v-divider class="pb-3" />
      <v-form v-model="form.valid" @submit.prevent="create()">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.name"
              outlined
              label="Lagername"
              :rules="[(v) => !!v || 'Item is required']"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.number"
              outlined
              label="Lagernummer"
              :rules="[(v) => !!v || 'Item is required']"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end">
          <v-btn color="primary" type="submit">
            Speichern
          </v-btn>
        </div>
      </v-form>
    </v-card>
    <v-spacer />
  </div>
</template>

<script>
export default {
   name: 'WarehouseCreate',
   data () {
      return {
         form: this.$inertia.form({
            name: null,
            number: null,
            valid: false,
         }),
      }
   },
   methods: {
      create () {
         this.form.post(this.route('warehouse.store'), {
            preserveScroll: true,
            onSuccess: () => {
               this.form.reset()
               this.$emit('created')
            }
         })
      },
   },
}
</script>

<style></style>
